const initialState = {
    dropzoneFiles:[],
    readyToImportFiles : [],
    inProgressFiles: [],
    includeHistory : true,
    historyData:[],
    tempData:[]

};



export default (state = initialState, action) => {

    switch (action.type) {
        case "ADD_DROPZONE_FILES": {
         
            return {
                ...state,
                dropzoneFiles : action.payload
            };
        }
        case "INCLUDE_HISTORY": {
           console.log("include history reducer")
             return {
                 ...state,
                 includeHistory : !state.includeHistory,
                 dropzoneFiles:[],
             };
         }

         case "UPDATE_READYTOIMPORT_DATASET": {
            console.log("include update final dataset reducer")
              return {
                  ...state,
                  dropzoneFiles:[],
                  readyToImportFiles : action.payload
              };
          }

          case "CLEAR_DROPZONE_DATA": {
            
              return {
                  ...state,
                  dropzoneFiles:[],
                  
              };
          }
          case "CURRENT_STATE_LOADED_FILES_FINAL" :{
            return {
                ...state,
                inProgressFiles: state.inProgressFiles.concat(action.payload),
                readyToImportFiles:[],
                dropzoneFiles:[]
                
            }
          }

          case "IMPORTED_FILES_STATUS_UPDATE" :{
             
            return {
                ...state,
                inProgressFiles: action.payload,
                dropzoneFiles:[]
               
                
            }
          }

          case "UPDATE_HISTORY_DATA" :{
              console.log("in UPDATE_HISTORY_DATA")
            let historyPayload = action.payload
            historyPayload.sort(function (a, b) {
              var dateA = new Date(a.timestamp * 1000), dateB = new Date(b.timestamp * 1000);
              return dateB - dateA;
            });
            return {
                ...state,
                historyData: historyPayload,
                tempData:[]
               
                
            }
          }

          
          case "CLEAR_ALL": {
            
            return {
                ...state,
                readyToImportFiles:[],
                dropzoneFiles:[]
            };
        }

          

        default: {
            return state;
        }
    }
}



